var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99922 1.7998C4.00511 1.7998 3.19922 2.60569 3.19922 3.5998V16.1998L6.34922 14.3998L9.49922 16.1998L12.6492 14.3998L15.7992 16.1998V3.5998C15.7992 2.60569 14.9933 1.7998 13.9992 1.7998H4.99922ZM9.23562 5.1362C9.58709 4.78473 9.58709 4.21488 9.23562 3.86341C8.88414 3.51194 8.31429 3.51194 7.96282 3.86341L5.26282 6.56341C4.91135 6.91488 4.91135 7.48473 5.26282 7.8362L7.96282 10.5362C8.31429 10.8877 8.88414 10.8877 9.23562 10.5362C9.58709 10.1847 9.58709 9.61488 9.23562 9.26341L8.07201 8.0998H9.49922C10.9904 8.0998 12.1992 9.30864 12.1992 10.7998V11.6998C12.1992 12.1969 12.6022 12.5998 13.0992 12.5998C13.5963 12.5998 13.9992 12.1969 13.9992 11.6998V10.7998C13.9992 8.31452 11.9845 6.2998 9.49922 6.2998H8.07201L9.23562 5.1362Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.eaf2fb3ac96ac733042dead6f00e0d09.svg";
export { ForwardRef as ReactComponent };